import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {LoginInfo, SERVER_URL, USER_URL,} from '../contexts/Configuration';

type  InitialState = {
    token: string | null,
    userName: string | undefined,
    userEmail: string
    roles: string[]
}

const initialState: InitialState = {
    token: localStorage.getItem('token') || null,
    userEmail: localStorage.getItem('userEmail') || '',
    userName: '',
    roles: []
}

export const updateUserConfig = createAsyncThunk<
    {},
    { token: string, config: { broadcastEnabled?: boolean } },
    { rejectValue: string }
>(
    'user/update',
    async (params, {rejectWithValue}) => {

        return await fetch(`${SERVER_URL}${USER_URL}/config`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${params.token}`
            },
            body: JSON.stringify(params.config)
        }).then(response => {
            if (response.ok) {
                console.log('SENT OK!')
                return {};
            } else {
                console.log('FAIL on [user] config update:', response.json())
                throw new Error('FAIL!!!!!!!')
            }
        }).catch(error => {
            console.log('FAIL on [user] config update:', error)
            return rejectWithValue(error.message)
        })
    }
)

const accessSlice = createSlice({
    name: 'access',
    initialState,
    reducers: {
        saveUserInfo(state, action: PayloadAction<LoginInfo>) {
            const userToken = action.payload.token;
            const roles = action.payload.roles;
            const userEmail = action.payload.account.username;

            localStorage.setItem('token', userToken);
            localStorage.setItem('userEmail', userEmail);

            state.token = userToken;
            state.userName = action.payload.account.name;
            state.userEmail = userEmail;
            state.roles = roles;
        },
        updateUserConfig(state, action: PayloadAction<{ broadcastEnabled: boolean }>) {
        }
    },
    extraReducers: (builder) => {
        builder.addCase(updateUserConfig.fulfilled, (state, action) => {
            console.log('retrieveUserInfo.fulfilled', action);
        })
        builder.addCase(updateUserConfig.rejected, (state, action) => {
            console.log('retrieveUserInfo.rejected', action);
        })
    }
});

export default accessSlice.reducer;
export const {saveUserInfo} = accessSlice.actions;
